import './text-field.scss';
import classNames from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { If, Then } from 'react-if';
import { Link } from 'react-router-dom';

const TextField = ({
  name,
  label,
  placeholder,
  type,
  readOnly,
  required,
  variant,
  link,
  autocomplete,
}) => {
  const { control } = useFormContext();

  return (
    <div className="form-control">
      <label htmlFor={name} className="form-control__label">
        {label}
      </label>

      <Controller
        render={({ field, fieldState }) => (
          <>
            <div className="form-control__text">
              <input
                {...field}
                id={name}
                className={classNames('form-control__input', { 'has-error': !!fieldState.error })}
                placeholder={placeholder}
                type={type}
                required={required}
                readOnly={readOnly}
                data-testid={name}
                autoComplete={autocomplete}
              />
              <If condition={variant === 'link'}>
                <Then>
                  <Link
                    className="form-control__text__btn form-control__text__edit-btn"
                    to={link}
                  >
                    Edit
                  </Link>
                </Then>
              </If>
            </div>
            {fieldState.error && (
              <span className="form-control__error">
                {fieldState.error.message}
              </span>
            )}
          </>
        )}
        control={control}
        name={name}
      />
    </div>
  );
};

export default TextField;
